<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="advanced-search">

        <div id="search-navigation">
            <div  v-on:click="changeSearchType('educational')">جستجوی تخصصی تحصیلی</div>
            <div  v-on:click="changeSearchType('immigration')">جستجوی تخصصی برنامه های مهاجرتی</div>
            <div class="navigation-border-bottom" :style="[currentNavigation=='navOne' ? {'right':'0'} : {'left':'0'}]"></div>
        </div>

        <div class="search-container" v-show="currentNavigation=='navOne'">
            <ul class="main-ul-one" v-for="educationalItems in selectionItems[0].educational" :key="educationalItems">

                <li class="main-li-one">
                    <span v-on:click="showFilterList('1')">رشته تحصیلی:</span>
                    <div v-on:click="showFilterList('1')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '1' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '1'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="studyField in educationalItems.studyField" :key="studyField">
                                <input v-model="studyField.status"  v-on:change="(e)=>addFilter(e,studyField)" class="checkbox" type="checkbox" :id="studyField.js_id" name="cb">
                                <label :for = "studyField.js_id">
                                    {{studyField.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>

                <li class="main-li-one">
                    <span v-on:click="showFilterList('2')">شهر:</span>
                    <div v-on:click="showFilterList('2')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '2' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '2'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="city in educationalItems.city" :key="city">
                                <input v-model="city.status"  v-on:change="(e)=>addFilter(e,city)" class="checkbox" type="checkbox" :id="city.js_id" name="cb">
                                <label :for = "city.js_id">
                                    {{city.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>


                <li class="main-li-one">
                    <span v-on:click="showFilterList('3')">مقطع:</span>
                    <div v-on:click="showFilterList('3')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '3' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '3'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="section in educationalItems.section" :key="section">
                                <input v-model="section.status"  v-on:change="(e)=>addFilter(e,section)" class="checkbox" type="checkbox" :id="section.js_id" name="cb">
                                <label :for = "section.js_id">
                                    {{section.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>

                <li class="main-li-one">
                    <span v-on:click="showFilterList('4')">شهریه:</span>
                    <div v-on:click="showFilterList('4')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '4' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '4'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="tuition in educationalItems.tuition" :key="tuition">
                                <input v-model="tuition.status"  v-on:change="(e)=>addFilter(e,tuition)" class="checkbox" type="checkbox" :id="tuition.js_id" name="cb">
                                <label :for = "tuition.js_id">
                                    {{tuition.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>

                <li class="main-li-one">
                    <span v-on:click="showFilterList('5')">نمره آیلس:</span>
                    <div v-on:click="showFilterList('5')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '5' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '5'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="iELTSScore in educationalItems.iELTSScore" :key="iELTSScore">
                                <input v-model="iELTSScore.status"  v-on:change="(e)=>addFilter(e,iELTSScore)" class="checkbox" type="checkbox" :id="iELTSScore.js_id" name="cb">
                                <label :for = "iELTSScore.js_id">
                                    {{iELTSScore.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>

        <div class="search-container" v-show="currentNavigation=='navTwo'">
            <ul class="main-ul-one" v-for="immigrationItems in selectionItems[0].immigration" :key="immigrationItems">
                <li class="main-li-one li-section-two">
                    <span v-on:click="showFilterList('6')">سن:</span>
                    <div v-on:click="showFilterList('6')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '6' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '6'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="_age in immigrationItems.age" :key="_age">
                                <input v-model="_age.status"  v-on:change="(e)=>addFilter(e,_age)" class="checkbox" type="checkbox" :id="_age.js_id" name="cb">
                                <label :for = "_age.js_id">
                                    {{_age.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>

                <li class="main-li-one li-section-two">
                    <span v-on:click="showFilterList('7')">تحصیلات:</span>
                    <div v-on:click="showFilterList('7')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '7' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '7'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="_education in immigrationItems.education" :key="_education">
                                <input v-model="_education.status"  v-on:change="(e)=>addFilter(e,_education)" class="checkbox" type="checkbox" :id="_education.js_id" name="cb">
                                <label :for = "_education.js_id">
                                    {{_education.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>


                <li class="main-li-one li-section-two">
                    <span v-on:click="showFilterList('8')">سطح زبان:</span>
                    <div v-on:click="showFilterList('8')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '8' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '8'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="_languageLevel in immigrationItems.languageLevel" :key="_languageLevel">
                                <input v-model="_languageLevel.status"  v-on:change="(e)=>addFilter(e,_languageLevel)" class="checkbox" type="checkbox" :id="_languageLevel.js_id" name="cb">
                                <label :for = "_languageLevel.js_id">
                                    {{_languageLevel.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>


                <li class="main-li-one li-section-two">
                    <span v-on:click="showFilterList('9')">سرمایه:</span>
                    <div v-on:click="showFilterList('9')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '9' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '9'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="_fund in immigrationItems.fund" :key="_fund">
                                <input v-model="_fund.status"  v-on:change="(e)=>addFilter(e,_fund)" class="checkbox" type="checkbox" :id="_fund.js_id" name="cb">
                                <label :for = "_fund.js_id">
                                    {{_fund.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>


                <li class="main-li-one li-section-two">
                    <span v-on:click="showFilterList('10')">تجربه:</span>
                    <div v-on:click="showFilterList('10')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '10' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '10'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="_experience in immigrationItems.experience" :key="_experience">
                                <input v-model="_experience.status"  v-on:change="(e)=>addFilter(e,_experience)" class="checkbox" type="checkbox" :id="_experience.js_id" name="cb">
                                <label :for = "_experience.js_id">
                                    {{_experience.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>



                <li class="main-li-one li-section-two">
                    <span v-on:click="showFilterList('11')">اقوام مقیم:</span>
                    <div v-on:click="showFilterList('11')" class="img-arrow-container arrow-bordered">
                        <img :style="{transform: 'rotate(' + (checkBoxContainerShow == '11' ? '180deg' : 0) + ')'}"  width="7" height="5" src="../../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="">
                    </div>
                    <div class="check-box-container" v-show="checkBoxContainerShow == '11'">
                        <ul class="main-ul-two">
                            <li class="main-li-two"  v-for="_relatives in immigrationItems.relatives" :key="_relatives">
                                <input v-model="_relatives.status"  v-on:change="(e)=>addFilter(e,_relatives)" class="checkbox" type="checkbox" :id="_relatives.js_id" name="cb">
                                <label :for = "_relatives.js_id">
                                    {{_relatives.filter_name}}
                                </label>
                            </li>
                        </ul>
                    </div>
                </li>

            </ul>
        </div>

        <div class="filter-container-one"  v-on:click="showFilterList('')">
            <div class="explain-box">فیلتر های اعمال شده:</div>
            <div class="filter-box" v-if="filterItems[0]">

                <div class="filter" v-for="item in filterItems" :key="item">
                    <label style="display: inline-block;padding-right: 15px" class="close-filter-btn"  :for = "item.js_id">X</label>
                    <span class="close-filter-btn-txt">
                        {{item.filter_name}}
                    </span>
                </div>

            </div>
            <div class="filter-box" v-else style="background-color: #f5f6fa;height: 50px;"></div>
        </div>

        <div class="filter-results">
            <div class="title form-title">
                <ul>
                    <li>
                        <img width="30" height="30" src="../../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                      نتایج
                    </li>
                </ul>
            </div>
            <div class="results-container"  v-if="searchResults">
                <div class="main-results-content" >
                    <ul>
                        <li v-for="item in searchResults" :key="item">
                            <div class="text-content">
                                {{item.explain}}
                            </div>
                            <a :href="item.link"  class="btn-content" target="_blank">
                                مشاهده
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else style="height: 250px;display: flex;justify-content: center;align-items: center ;background-color: #f5f6fa;">
                موردی یافت نشد!
            </div>


        </div>


    </div>
    <PanelLoader v-if="loadingMood"/>
</template>
<script>
    import axios from 'axios'
    import Alert from "../../components/Alert"
    import PanelLoader from "../../components/PanelLoader"
    export default {
        name: "AdvancedSearch",
        components:{
            Alert,
            PanelLoader
        },
        data(){
            return{
                checkBoxContainerShow:'',
                filterItemsOne: [],
                filterItemsTwo: [],
                filterItems:[],
                selectionItems: [
                    {
                        educational: [
                            {
                                city: [],
                                studyField: [],
                                section: [],
                                tuition: [],
                                iELTSScore: [
                                    {
                                        filter_name: '9',
                                        js_id:'iELTSScore10',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '8.5',
                                        js_id:'iELTSScore9',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '8',
                                        js_id:'iELTSScore8',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '7.5',
                                        js_id:'iELTSScore7',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '7',
                                        js_id:'iELTSScore6',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '6.5',
                                        js_id:'iELTSScore5',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '6',
                                        js_id:'iELTSScore4',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '5.5',
                                        js_id:'iELTSScore3',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '5',
                                        js_id:'iELTSScore2',
                                        filter_type:'iELTSScore',
                                    },
                                    {
                                        filter_name: '4.5',
                                        js_id:'iELTSScore1',
                                        filter_type:'iELTSScore',
                                    },
                                ],
                            }
                        ],
                        immigration: [
                            {
                                age: [],
                                education: [],
                                languageLevel: [],
                                fund:[],
                                experience: [],
                                relatives: [],
                            }
                        ],
                    }
                ],
                currentNavigation:'navOne',
                alertContent: null,
                loadingMood: false,
                searchResults:null
            }
        },
        methods:{
            changeSearchType(type){
                if(type=='educational'){
                    this.getSelectionItems(type);
                    this.currentNavigation='navOne';
                    this.searchResults = null;
                    this.filterItems = [];
                }else{
                    this.getSelectionItems(type);
                    this.currentNavigation='navTwo' ;
                    this.searchResults = null;
                    this.filterItems = [];
                }
            },
            async getSelectionItems(type){
                try {
                    this.loadingMood = true;
                    const response = await axios.get('api/userDashboard/getAdvancedSearchOptions/'+type, {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood = false;
                    if(type == 'educational'){
                        this.selectionItems[0].educational[0].city = response.data.options.city_options;
                        this.selectionItems[0].educational[0].studyField = response.data.options.study_field_options;
                        this.selectionItems[0].educational[0].section = response.data.options.level_options;
                        this.selectionItems[0].educational[0].tuition = response.data.options.tuition_options;
                    }else{
                        this.selectionItems[0].immigration[0].age = response.data.options.age_options;
                        this.selectionItems[0].immigration[0].education = response.data.options.education_options;
                        this.selectionItems[0].immigration[0].languageLevel = response.data.options.language_level_options;
                        this.selectionItems[0].immigration[0].fund = response.data.options.fund_options;
                        this.selectionItems[0].immigration[0].experience = response.data.options.experience_options;
                        this.selectionItems[0].immigration[0].relatives = response.data.options.resident_relatives_options;
                    }
                } catch (error) {
                    this.loadingMood = false;
                    this.alertContent = {
                        message: 'خطا در انجام عملیات!',
                        imageUrl: require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType: 'close',//close
                        buttonText: 'تایید',
                        buttonLink: '',///personal-info
                        waitingMode: false
                    };
                }
            },
            showFilterList(filterNum){
                if(this.checkBoxContainerShow==filterNum){
                    this.checkBoxContainerShow=''
                }else{
                    this.checkBoxContainerShow=filterNum
                }
            },
            addFilter(e,filter){
                if(this.currentNavigation=='navOne'){
                    if(e.target.checked){
                        const result =  this.filterItemsOne.find(({ js_id }) => js_id ==  filter.js_id);
                        if(result==undefined){
                            this.filterItemsOne.push(filter);
                        }
                    }else{
                        const index = this.filterItemsOne.findIndex(x => x.js_id == filter.js_id);
                        this.filterItemsOne.splice(index,1);
                    }
                    this.filterItems=this.filterItemsOne;
                    this.applyFilters('educational');
                }
                else{
                    if(e.target.checked){
                        const result =  this.filterItemsTwo.find(({ js_id }) => js_id ==  filter.js_id);
                        if(result==undefined){
                            this.filterItemsTwo.push(filter);
                        }
                    }else{
                        const index = this.filterItemsTwo.findIndex(x => x.js_id == filter.js_id);
                        this.filterItemsTwo.splice(index,1);
                    }
                    this.filterItems=this.filterItemsTwo;
                    this.applyFilters('immigration');
                }

            },


            async applyFilters(type){
                try {
                    console.log(this.filterItems);
                    this.loadingMood = true;
                    const response = await axios.post('api/userDashboard/getAdvancedSearchResults/'+type,this.filterItems, {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood = false;

                    this.searchResults = response.data.results;

                } catch (error) {
                    this.loadingMood = false;
                    this.alertContent = {
                        message: 'خطا در انجام عملیات!',
                        imageUrl: require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType: 'close',//close
                        buttonText: 'تایید',
                        buttonLink: '',///personal-info
                        waitingMode: false
                    };
                }
            },
        },
        created(){
            this.getSelectionItems('educational');
        }

    }
</script>

<style lang="scss" scoped>
    .results-container{
        width: 100%;
        height: 250px;
        overflow-y: scroll;
        padding-left: 15px;
    }
    .main-results-content{
        ul{
            padding: 0;
            list-style-type: none;
            li{
                width: 100%;
                display: flex;
                justify-content: space-between;
                height: auto;
                margin-bottom: 10px;
                .btn-content{
                    text-decoration:underline;
                    align-self: end;
                }
                .text-content{
                    padding-left: 10px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #e3e3e3;
                    text-align: right;
                }

            }
        }
        width: 100%;
        height: auto;
    }

    .title {
        margin-top: -20px;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
        padding: 0;
        right: 0;

        ul {
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;
            padding: 0;

            li {
                background-color: white;
                padding: 0 0 0 15px;
                img {
                    margin-top: 5px;
                    width: 9px !important;
                    height: auto !important;
                }


                font-size: 22px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: justify;
                color: #1a1a1a;



                display: inline-block;

                span {
                    color: #cc171d;
                }
            }
        }

    }
    .form-title {
        font-size: 22px !important;
    }




    .filter-results{
        width: 100%;
        height: 100%;

    }
    .navigation-border-bottom{
        width:50%;
        height: 5px;
        border-radius: 2.5px;
        background-color: #fe7063;
        position: absolute;
        bottom: -2.5px;
    }
    .close-filter-btn-txt{
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
    }
    .close-filter-btn{
        height: 100%;
        margin-right: 10px;
        margin-left: 0;
        width: 24px;
        font-size: 15px;
        color: #162336;;
    }
    .explain-box{
        display: inline-block;
        width: 160px;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
    }
    .filter-box{
        text-align: right;
        display: inline-block;
        width: calc( 100% - 160px );
    }
    .filter{
        cursor: pointer;
        padding: 10px;
        width: max-content!important;
        border-radius: 10px;
        background-color: #f3f4f5;
        display: inline-block;
        margin: 5px;
    }
    .filter-container-one{
        margin-top: 20px;
        display: flex;
        width: 100%;
        min-height: 100px;
    }

    @media (max-width: 1300px) {
        .filter-container-one{
            display: block;
            margin-bottom: 50px;
            .explain-box{
                display: block;
                width: 100%;
            }
            .filter-box{
                display: block;
                width: 100%;
            }
        }

    }


/****/
       .checkbox{
           position: absolute;
       }
       input[type="checkbox"] {
           visibility: hidden;
       }
       label {
           display: flex;
           align-items: center;
           margin: 0!important;
           cursor: pointer;
       }
       input[type="checkbox"] + label:before {
           border: 2px solid  #fe7063;
           content: "\00a0";
           display: inline-block;
           font: 16px/1em sans-serif;
           height: 16px;
           margin-left: 10px;
           padding: 0;
           width: 16px!important;
           border-radius: 3px;
    }
    input[type="checkbox"]:checked + label:before {
        background: #fe7063;
        color    : white;
        content: "\2713";
        text-align: center;
    }
    input[type="checkbox"]:checked + label:after {
        font-weight: bold;
    }

    input[type="checkbox"]:focus + label::before {
        outline: rgb(59, 153, 252) auto 5px;
    }

    label{
        font-size: 14px;
    }
/****/








    .arrow-bordered{
        border-left: 1px solid #e3e3e3;
    }
    .search-container{
        border-bottom: 1px solid #e3e3e3;
        width: 100%;
        .main-ul-one{
            list-style-type: none;
            padding: 0;
            margin: 0;
            .main-li-one{
                font-family: IRANSans;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                letter-spacing: normal;
                color: #162336;
                position: relative;
                text-align: right;
                min-width: 168px;
                min-height: 50px;
                height: auto;
                display: inline-block;
                line-height: 50px;
                cursor: pointer;
                .img-arrow-container{
                    display: block;
                    width: 25px;
                    height: 25px;
                    position: absolute;
                    left: 20px;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    padding-left: 10px;
                    padding-right: 10px;
                    img{
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        margin: auto;
                    }
                }
                .last-arrow{
                    left: 0;
                }
            }
        }
    }

    .li-section-two{
        min-width: 140px!important;
    }

    .check-box-container{
        position: absolute;
        width: 150px;
        height: auto;
        right: 0;
        top: 50px;
        background-color: white;
        border-radius: 10px;
        border: 2px solid #e3e3e3;
        z-index: 100;
        padding: 0 5px;

        max-height: 350px;
        overflow: hidden;
        overflow-y: scroll;
        min-height: 50px;

        .main-ul-two{
            list-style-type: none;
            margin: 0;
            padding: 5px 5px;
            .main-li-two{
                /*display: flex;*/
                /*justify-content: right;*/
                /*align-items: center;*/
                line-height: 20px!important;
                width: 100%;
                min-height: 20px;
                height: auto;
                padding: 10px 0;
                label{

                }
            }

        }
    }
    .check-box-input{
        width: 10px!important;
        height: auto;
    }

    #advanced-search{
        padding: 30px;
        #search-navigation{
            padding-bottom: 20px;
            position: relative;
            width: 100%;
            /*display: flex;*/
            /*justify-content: center;*/
            min-height: 50px;
            height: auto;
            border-bottom: solid 1px #e3e3e3;
            div {
                cursor: pointer;
                display: inline-block;
                width: 50%;
                min-width: 50%;
                font-size: 14px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #162336;
                &:nth-child(1){

                }
                &:nth-child(2){

                }
            }
        }
        #selector-container{
            width: 100%;
            min-height: 54px;
            height: auto;
        }
    }
</style>